import { mount } from 'enzyme';
import * as React from 'react';

import {
  ProgressBarComponent,
  TInvestmentReturnProgressProps,
} from './progressBar';
import { TInvestmentReturn } from '..';

let height = 50;
let investmentAmount = 10000;
let investmentReturnModels: TInvestmentReturnProgressProps[] = [];
let allSeries: TInvestmentReturn[] = [
  {
    Gain: 4000,
    GainPercent: 4,
    Loss: -1100,
    LossPercent: -11,
    AverageReturn: 2500,
    AverageReturnPercent: 2.5,
    Key: 1,
  },
];

let seriesReturns: TInvestmentReturn = {
  Gain: 4000,
  GainPercent: 4,
  Loss: -1100,
  LossPercent: -11,
  AverageReturn: 2500,
  AverageReturnPercent: 2.5,
  Key: 1,
};

investmentReturnModels.push(
  {
    allSeries,
    height,
    investmentAmount,
    seriesReturns,
  },
  {
    allSeries,
    height,
    investmentAmount,
    seriesReturns,
  },
);

describe('Button', () => {
  test('should match snapshot and styles for default props', () => {
    expect(
      mount(
        <ProgressBarComponent
          seriesReturns={seriesReturns}
          investmentAmount={investmentAmount}
          height={height}
          allSeries={allSeries}
        />,
      ),
    ).not.toBeUndefined();
  });
});

describe('Button', () => {
  allSeries[0].Gain = 0;
  allSeries[0].Loss = 0;

  test('Progress bar with gain and loss 0', () => {
    expect(
      mount(
        <ProgressBarComponent
          seriesReturns={seriesReturns}
          investmentAmount={investmentAmount}
          height={0}
          allSeries={allSeries}
        />,
      ),
    ).not.toBeUndefined();
  });
});
